const STORAGE_KEYS = {
    COOKIE_NOTIFICATION: 'cookieNotification',
    HIDE_WISH_LIST_INFO_CARD: 'hideWishListInfoCard',
    ITEMS_CLICK: 'items-click',
    ITEMS_IN_VIEWPORT: 'items-in-viewport',
    SAVE_SEARCH_HINT: 'save-search-tooltip',
    SEARCH_RECENT: 'search-recent',
    SELLING_DONT_ASK_FOR_SCHENKER_UPSELL: 'dontAskForSchenkerUpsell',
    WEB_PUSH_ACCEPTED: 'web_push_accepted',
    WEB_PUSH_SHOWN_MODALS: 'webPushModalsShown',
    COMBINED_SHIPPING_ALERT_SOLD: 'hideCombinedShippingAlert_sold',
    COMBINED_SHIPPING_ALERT_BOUGHT: 'hideCombinedShippingAlert_bought',
    COMBINED_SHIPPING_ALERT_SYI: 'hideCombinedShippingAlert_syi',
    CHECKOUT_DONT_CONFIRM_REQUEST_COMBINED_SHIPPING:
        'dontConfirmRequestCombinedShipping',
    SELLER_LIST_COMPACT_VIEW: 'sellerListCompactView',
    // State caches
    CACHE_MESSAGING_BADGES: 'cache.messagingBadges',
    CACHE_RECENTLY_VIEWED_ITEMS: 'cache.recentlyViewedItems',
    CACHE_SYSTEM_MESSAGES: 'cache.systemMessages',
    // Apple ID login user
    APPLE_ID_USER: 'appleId.user'
};

const STORAGE_VALUES = {
    SAVE_SEARCH_HINT_CLICKED: 'CLOSE_CLICKED'
};

export { STORAGE_KEYS, STORAGE_VALUES };
